// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"788":"1e7b0e02","955":"b31c4345"}[chunkId] + ".chunk.css";
};